import MDBox from "components/MDBox";
import Author from "components/Table/Author";
import Status from "components/Table/Status";
import { IconButton, Tooltip } from "@mui/material";

import Constants, { Icons } from "utils/Constants";
import { formatSnagDate, formatSnagStatus } from "layouts/snag/data/SnagData";

const SNAG_DETAILS_PREVIEW_LENGTH = 80;

export default function ProjectMapSnagData(snagList, viewSnagDetails) {
  const snagRows =
    snagList?.map((item, index) => ({
      srNo: <Author name={index + 1} />,
      dateCreated: <Author name={formatSnagDate(item?.dateAdded)} />,
      details:
        item?.details?.length > SNAG_DETAILS_PREVIEW_LENGTH ? (
          <Tooltip title={item.details}>
            <span>
              <Author
                name={`${item.details.slice(0, SNAG_DETAILS_PREVIEW_LENGTH)}...`}
                style={{ textTransform: "none" }}
              />
            </span>
          </Tooltip>
        ) : (
          <Author name={item?.details} style={{ textTransform: "none" }} />
        ),
      status: <Status title={formatSnagStatus(item?.status)} />,
      action: (
        <MDBox>
          <IconButton
            aria-label="view snag"
            color="info"
            onClick={() => viewSnagDetails(item?.[Constants.MONGOOSE_ID])}
          >
            {Icons.VIEW}
          </IconButton>
        </MDBox>
      ),
    })) || [];

  return {
    snagColumns: [
      { Header: "No.", accessor: "srNo", width: "5%" },
      { Header: "Date Created", accessor: "dateCreated", align: "left", width: "15%" },
      { Header: "Details", accessor: "details", align: "left", width: "55%" },
      { Header: "Status", accessor: "status", align: "left", width: "15%" },
      { Header: "Action", accessor: "action", align: "center", width: "10%" },
    ],
    snagRows,
  };
}
